import { render, staticRenderFns } from "./PrimaryHeader.vue?vue&type=template&id=0527c8e2&"
import script from "./PrimaryHeader.vue?vue&type=script&lang=js&"
export * from "./PrimaryHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports